import DistrictCard from '../components/DistrictCard';
import noimage from "../assets/mocks/noimage.png"
export default function DistrictGrid(content: any) {

	return (
		<div className="d-flex mx-5">
			<div className="row g-4 h-100">
				<div className="col-12 col-sm-6 col-md-7 d-flex flex-column justify-content-center h-50 m-auto">
					<h1 className="display-6 text-uppercase text-primary fw-bolder">Business Districts in the Philippines</h1>
					<img loading="lazy"
						src="/media/divisors/640_business-districts-bar.webp"
						className="img-fluid" alt="Image" />

					<p className="fs-2 mt-5">Our dedicated teams across multiple offices in the Philippines can guide your entry into any business district in the country.</p>
				</div>
				<div className="col-12 col-sm-6 col-md-5 ">
					<DistrictCard
						title={content.object[0].title.rendered}
						image={content.object[0]?._embedded ? content.object[0]?._embedded['wp:featuredmedia'][0]?.source_url : noimage}
						body={content.object[0].acf.blurb}
						link={"/business-districts/" + content.object[0].slug}
						height="h-100"
					/>
				</div>
				{content.object.slice(1).map((project: any) => (
					<div className="col-12 col-sm-6 col-md-4 col-lg-3" key={project.slug}>
						<DistrictCard
							title={project.title.rendered}
							image={project?._embedded ? project?._embedded['wp:featuredmedia'][0]?.source_url : noimage}
							body={project.acf.blurb}
							link={"/business-districts/" + project.slug}
							height=""
						/>
					</div>
				)
				)}
			</div>

		</div>

	)
}